export interface IAuthenticatedUserApiResponse {
	userDetails: IAuthenticatedUserModel[];
	error: boolean;
}

export interface IUnAuthenticatedUserModel {
	id?: number;
	name: string;
	emailAddress: string;
	countryCode: string;
	mobileNumber: string;
	accessibleModules: string;
}

export const initialUnAuthenticatedUser: IUnAuthenticatedUserModel = {
	id: 0,
	name: '',
	emailAddress: '',
	countryCode: '',
	mobileNumber: '',
	accessibleModules: '',
};

export enum AuthenticatedUserStatus {
	Pending,
	Verified,
}

export interface IAuthenticatedUserModel {
	id: number;
	primaryRegistrationId: number;
	name: string;
	emailAddress: string;
	countryCode: string;
	mobileNumber: string;
	createdOn?: Date;
	status: AuthenticatedUserStatus;
	accessibleModules: string;
	accessIdentifier?: string;
	verifiedOn?: Date;
}

export const initialAuthenticatedUser: IAuthenticatedUserModel = {
	id: 0,
	primaryRegistrationId: 0,
	name: '',
	emailAddress: '',
	countryCode: '',
	mobileNumber: '',
	status: AuthenticatedUserStatus.Pending,
	accessibleModules: '',
};

export enum ModulesEnumValue {
	Home = 1,
	Documents,
	TaxPayments,
	DistributeK1s,
}

export const availableModulesList = [
	{ label: 'Home', value: ModulesEnumValue.Home },
	{ label: 'Documents', value: ModulesEnumValue.Documents },
	{ label: 'Tax Payments', value: ModulesEnumValue.TaxPayments },
	{ label: 'Distribute K-1s', value: ModulesEnumValue.DistributeK1s },
];

export type IDeleteThirdPartyResponse = {
	isSuccess: boolean;
	error: boolean;
};

export type ISendLinkToThirdPartyResponse = {
	isSuccess: boolean;
	error: boolean;
};
